export const getTempId = () => {
  const sourceArray: Uint8Array = new Uint8Array(1);
  const randomValue: number = crypto.getRandomValues(sourceArray)[0];
  return (randomValue / Math.pow(2, 8)).toString(36).substr(2, 12);
};
